import React from 'react';
import styled from '@emotion/styled';

import { getColor } from './UICommon';

interface StyleProps {
  imageUrl: string;
  isCarousel?: boolean;
  isFullScreen?: boolean;
  imageBackgroundSize?: string;
  imageHeight?: string;
}

const Div = styled.div`
  color: ${getColor('WHITE')};
  border-radius: ${(props: StyleProps) => (props.isFullScreen ? 0 : '8px')};
  max-width: ${(props: StyleProps) => (props.isFullScreen ? '100%' : '311px')};
  height: ${(props: StyleProps) => (props.imageHeight ? props.imageHeight : props.isFullScreen ? '375px' : '322px')};
  background-image: ${(props: StyleProps) => `url("${props.imageUrl}")`};
  background-size: ${(props: StyleProps) => (props.imageBackgroundSize ? props.imageBackgroundSize : 'cover')};
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end;
  @media (max-width: 600px) {
    margin-right: ${(props: StyleProps) => (props.isCarousel ? '12px' : 0)};
  }
`;

const Text = styled.div`
  font-style: italic;
  font-family: 'Source Serif Pro';
  padding: 20px 24px;
  &.fullScreen {
    padding: 20px 32px;
  }
`;

const P = styled.p`
  font-weight: 700;
  text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  &.quoteFull {
    font-size: 36px;
    line-height: 36px;
    padding-bottom: 1px;
  }
  &.nameFull {
    font-size: 24px;
    line-height: 32px;
  }
  &.quote {
    font-weight: 900;
    font-size: 24px;
    line-height: 30px;
  }
  &.name {
    font-weight: 900;
    font-size: 16px;
    line-height: 24px;
  }
`;

export interface QuoteCardProps {
  quote?: string;
  quoteName?: string;
  imageUrl: string;
  isCarousel?: boolean;
  isFullScreen?: boolean;
  imageBackgroundSize?: string;
  imageHeight?: string;
}

export const QuoteCard = ({
  imageBackgroundSize,
  imageHeight,
  imageUrl,
  quote,
  isCarousel = false,
  quoteName,
  isFullScreen = false,
}: QuoteCardProps) => {
  return (
    <Div
      imageUrl={imageUrl}
      isCarousel={isCarousel}
      isFullScreen={isFullScreen}
      imageBackgroundSize={imageBackgroundSize}
      imageHeight={imageHeight}
    >
      <Text className={isFullScreen ? 'fullScreen' : ''}>
        {quote ? <P className={isFullScreen ? 'quoteFull' : 'quote'}>{quote}</P> : null}
        {quoteName ? <P className="name">{quoteName}</P> : null}
      </Text>
    </Div>
  );
};
